import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function SharedHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (sectionId: string) => {
    setMobileMenuOpen(false);
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80;
        const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  const handleLogoClick = () => {
    setMobileMenuOpen(false);
    navigate('/');
  };

  const navItems = [
    { label: 'ESG & Carbon', id: 'esg-carbon' },
    { label: 'Metals', id: 'metals' },
    { label: 'AI & Software', id: 'ai-software' },
    { label: 'About', id: 'about' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-white'
      }`}
    >
      <div className="border-b border-black/8">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
          <div className="flex items-center justify-between h-16 lg:h-20">
            {/* Logo — always links to "/" */}
            <a
              href="/"
              onClick={(e) => { e.preventDefault(); handleLogoClick(); }}
              className="flex items-center gap-3 cursor-pointer"
              aria-label="Precious Leader Trade Far East Limited — Home"
            >
              <img
                src="https://static.readdy.ai/image/2e4355bb8afb16b3015e9a84e75a64ec/50fde72ea7ea1006ed7bc96a5b4ff55a.png"
                alt="Precious Leader Trade Far East Limited"
                className="h-14 lg:h-20 w-auto"
              />
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-10">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleNavClick(item.id)}
                  className="text-[15px] font-medium text-[#111111] hover:text-[#B11226] transition-colors duration-200 relative group whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-[#B11226] transition-all duration-200 group-hover:w-full"></span>
                </button>
              ))}
              <button
                onClick={() => handleNavClick('contact')}
                className="bg-[#B11226] text-white text-[14px] font-semibold px-8 py-4 rounded-full hover:bg-[#8F0E1E] transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                Request a Call
              </button>
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center text-[#B11226] cursor-pointer ml-4"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-b border-black/8">
          <div className="max-w-[1400px] mx-auto px-5 py-7 flex flex-col gap-5">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(item.id)}
                className="text-[15px] font-medium text-[#111111] hover:text-[#B11226] transition-colors text-left whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => handleNavClick('contact')}
              className="bg-[#B11226] text-white text-[14px] font-semibold px-8 py-4 rounded-full hover:bg-[#8F0E1E] transition-colors mt-2 whitespace-nowrap self-start cursor-pointer"
            >
              Request a Call
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
